module.exports = ".row:nth-child(odd){\r\n    background: #f3f3f3;\r\n }"


//////////////////
// WEBPACK FOOTER
// ./src/app/grievence-lodging/grievence-lodging/grievence-lodging.component.css
// module id = ./src/app/grievence-lodging/grievence-lodging/grievence-lodging.component.css
// module chunks = main